import { User } from './user.model';
export class Collaborators {
  applicationId: string;
  user: User;
}
